import MUIKey from '@mui/icons-material/Key'

export const KeyIcon = MUIKey
